import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lp2-login-logo',
  styles: [
    `
      :host {
        display: flex;
        justify-content: center;
      }
      img {
        height: 45px;
        margin: 32px 0;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<img src="/images/logo_black_lg.png" draggable="false" alt="OpenEnglish" />`,
})
export class LoginLogoComponent {
  constructor() {
    this.addBodyClass();
  }

  addBodyClass() {
    const bodyElement = document.body;
    if (bodyElement) {
      bodyElement.classList.add('set-padding-top-to-zero-on-login');
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/header/login-logo/login-logo.component.ts